import { z } from 'zod';

/** `?storeId=` on /org/schedules/upcoming: one store's runs and dates. */
export const scheduleUpcomingSearchSchema = z.object({
  storeId: z.string().min(1).max(64).optional().catch(undefined),
});

export type ScheduleUpcomingSearch = z.infer<typeof scheduleUpcomingSearchSchema>;
